<template>
  <div class="page">
    <div class="sideNav">
      <a
        v-for="(nav, index) in navs"
        v-bind:key="nav.id"
        :class="{ active: active === index }"
        @click="clickItem(index)"
      >
        {{ nav.name }}
      </a>
    </div>
    <div class="sideContent">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "sideNav",
  props: ["navs", "active"],
  data() {
    return {
      user: { firstName: "first", secondName: "second" }
    };
  },
  methods: {
    clickItem(index) {
      this.$emit("change-nav", index);
    }
  }
};
</script>

<style scoped>
.page {
  display: flex;
  justify-content: space-between;
  width: 1280px;
}

.sideContent {
  width: 1000px;
}

.sideNav {
  width: 250px;
}
.sideNav a {
  display: block;
  box-sizing: border-box;
  width: 250px;
  height: 60px;
  /*background-color: #f1f5f7;*/
  border-left: 2px solid white;
  font-size: 16px;
  color: rgba(39, 39, 39, 1);
  line-height: 60px;
  padding-left: 50px;
}
.sideNav a:hover {
  background-color: #f1f5f7;
  border-left: 2px solid #0588cd;
}
.sideNav a.active {
  background-color: #f1f5f7;
  border-left: 2px solid #0588cd;
}
</style>
